export enum LevelTypes {
    CORPORATE = 151,
    CENTER = 153
}
